import { TsDOM as q} from '@/scripts/core/TsDOM'
import { MulticolumCarousel } from '@/scripts/section-multicolum-carousel/section-multicolum-carousel'

q.safeDefineElement(MulticolumCarousel)